export default function ServiceOverview() {
  const services = [
    {
      icon: 'wheelchair',
      title: 'Mobility Devices',
      description: 'Expert repair and maintenance for power wheelchairs, electric scooters, and mobility aids. We handle motor repairs, battery replacements, control system diagnostics, and complete overhauls.',
      items: ['Power Wheelchairs', 'Medical Scooters', 'Mobility Aids']
    },
    {
      icon: 'bed',
      title: 'Hospital Equipment',
      description: 'Professional servicing of hospital beds including motor repairs, remote control fixes, mattress platform adjustments, and safety rail maintenance for home and facility use.',
      items: ['Hospital Beds', 'Adjustable Beds', 'Medical Mattresses']
    },
    {
      icon: 'lift',
      title: 'Lift Systems',
      description: 'Comprehensive repair services for lift chairs and patient lifts. We specialize in motor replacement, upholstery repair, hydraulic system maintenance, and safety inspections.',
      items: ['Lift Chairs', 'Patient Lifts', 'Transfer Equipment']
    }
  ];

  return (
    <section id="service-overview" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <p className="text-gray-500 uppercase tracking-wider text-sm font-medium mb-4">
            COMPREHENSIVE REPAIR SOLUTIONS
          </p>
          <h2 className="text-5xl font-bold text-gray-900 leading-tight">
            Equipment We Service<br />
            With Excellence
          </h2>
        </div>

        {/* Service Cards */}
        <div className="grid md:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div 
              key={index}
              className="bg-white rounded-xl p-8 shadow-lg hover:shadow-xl transition-shadow duration-300"
            >
              {/* Icon */}
              <div className="w-16 h-16 flex items-center justify-center mb-6">
                {service.icon === 'wheelchair' && (
                  <i className="ri-wheelchair-line text-[#1e3a5f] text-6xl"></i>
                )}
                {service.icon === 'bed' && (
                  <i className="ri-hotel-bed-line text-[#1e3a5f] text-6xl"></i>
                )}
                {service.icon === 'lift' && (
                  <i className="ri-arrow-up-down-line text-[#1e3a5f] text-6xl"></i>
                )}
              </div>

              {/* Title */}
              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                {service.title}
              </h3>

              {/* Description */}
              <p className="text-gray-600 leading-relaxed mb-6">
                {service.description}
              </p>

              {/* Items List */}
              <ul className="space-y-2 mb-6">
                {service.items.map((item, idx) => (
                  <li key={idx} className="flex items-center text-gray-700">
                    <i className="ri-check-line text-[#14B8A6] mr-2"></i>
                    {item}
                  </li>
                ))}
              </ul>

              {/* Learn More Link */}
              <a 
                href="#request-form"
                className="text-[#14B8A6] font-semibold hover:text-[#0f9b8e] transition-colors cursor-pointer inline-flex items-center"
              >
                Learn More <i className="ri-arrow-right-line ml-1"></i>
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}